import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IdentityService } from '../../services/identity.service';
import { NotificationService } from '../../services/notification.service';
import { NativeBridgeService } from '../../services/native-bridge.service';
import { deviceMessageId } from '../../enums/device-message-id.enum';

@Component({
  selector: 'app-dialog-expiration',
  templateUrl: './dialog-expiration.component.html',
  styleUrls: ['./dialog-expiration.component.scss']
})
export class DialogExpirationComponent implements OnInit {
  confirmation: boolean;
  count: number = 0;
  timeOut;

  constructor(
    private dialogRef: MatDialogRef<DialogExpirationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    private router: Router,
    private translateService: TranslateService,
    private identityService: IdentityService,
    private bridgeService: NativeBridgeService
  ) {
    this.confirmation = data.confirmation;
  }

  ngOnInit() {
    this.temporizador(11, 0);
    this.dialogRef.afterClosed().subscribe((x) => {
      clearTimeout(this.timeOut);
      this.dialogRef.close({
        result: true
      });
    });
    let width = document.getElementById('btn').getBoundingClientRect().width.toString();
    document.getElementById('btn1').style.width = width + 'px';
  }

  temporizador(inicio, fin, stop?: boolean) {
    this.count = inicio;
    if (stop) {
      setTimeout((x) => (this.count = 10), 200);
      return;
    }
    if (inicio != fin && !stop) {
      this.count--;
      // console.log('La sesión expirará en ' + this.count + ' segundos.');
      this.timeOut = setTimeout((x) => this.temporizador(this.count, fin), 3000);
    } else {
      this.closeSession();
      this.notificationService.showWarning('Vuelve a iniciar sesión', 'Sesión expirada');
      this.dialogRef.close({
        result: true
      });
      return;
    }
  }

  keep() {
    this.temporizador(0, 0, true);
    clearTimeout(this.timeOut);
    this.dialogRef.close({
      result: true
    });
  }

  exit() {
    clearTimeout(this.timeOut);
    this.dialogRef.close({ result: 'close' });
    this.closeSession();
  }

  closeSession() {
    this.identityService.clearSession();
    if (
      this.bridgeService &&
      (this.bridgeService.nativeBridgeIsActive('androidBridge') || this.bridgeService.nativeBridgeIsActive('iOSBridge'))
    ) {
      this.bridgeService.sendMessageToDevice(JSON.stringify({ message_id: deviceMessageId.USER_SIGN_OUT }));
      console.log('Sent userSignOut to bridge');
    } else {
      console.warn('Bridge no disponible, solo navega a login');
    }
    this.router.navigate(['/login']);
  }

  resDialog() {
    if (this.confirmation) {
      return this.dialogRef.close(true);
    }
    return false;
  }

  translate(key: string, paramKey?: string): string {
    let param;
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }
}
